import { render, staticRenderFns } from "./MainDevice.vue?vue&type=template&id=4c459d2a&"
import script from "./MainDevice.vue?vue&type=script&lang=js&"
export * from "./MainDevice.vue?vue&type=script&lang=js&"
import style0 from "./MainDevice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports